import { FC } from 'react';

import { useIsMutating } from '@tanstack/react-query';

import { UpsellEntry } from '@telialt/common-order-cart/src/entries/UpsellEntry';
import { trackRemoveFromCartGA } from '@telialt/gtm-tracking/src/events';
import { EntryWithUpsell } from '@telialt/models/src/EshopModel';
import { useLogErrorEshop } from '@telialt/utils/src/datadog/useLogError';

import { useRemoveProductMutation } from '../../hooks/mutations/useRemoveProductMutation';
import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { ESHOP_MUTATION_KEY } from '../../model';
import { toSmallImage } from '../utils';

export const UpsellEntryConnected: FC<{ entry: EntryWithUpsell; showRemove: boolean }> = ({ entry, showRemove }) => {
    const { cart } = useCartQuery();

    const { removeProduct, removeProductError, removeProductIsLoading } = useRemoveProductMutation();
    useLogErrorEshop(removeProductError);

    const isRemovingEntryFromCart = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.DELETE_CART_ENTRY] }) > 0;

    const removeUpsellProduct = () => {
        removeProduct(entry.entryNumber);
        trackRemoveFromCartGA({ source: 'productUpsell', data: { cart, entry } });
    };

    return (
        <UpsellEntry
            name={entry.product.name}
            image={toSmallImage(entry.product.images)}
            price={entry.totalPrice}
            copyrightFee={entry.copyrightFee}
            isLoading={removeProductIsLoading}
            isDisabled={isRemovingEntryFromCart}
            onRemove={showRemove ? removeUpsellProduct : undefined}
        />
    );
};
